import { render, staticRenderFns } from "./RecordViewer.vue?vue&type=template&id=f9b53678&scoped=true"
import script from "./RecordViewer.vue?vue&type=script&lang=js"
export * from "./RecordViewer.vue?vue&type=script&lang=js"
import style0 from "./RecordViewer.vue?vue&type=style&index=0&id=f9b53678&prod&scoped=true&lang=scss"
import style1 from "./RecordViewer.vue?vue&type=style&index=1&id=f9b53678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b53678",
  null
  
)

export default component.exports